import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { stakeData } from "../utils/data";

const Stake = () => {
  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        <div className="right_wrap pb-4">
          <h4 className="subheading">Stake</h4>

          <div className="stake_top_box">
            <div className="stake_bx_grid">
              {" "}
              <div className="dashboard_box">
                <img
                  src={new URL("../../assets/st_bx_one.webp", import.meta.url)}
                  alt=""
                />
                <span>Total Value Staked</span>
                <h4>$42M</h4>
              </div>{" "}
              <div className="dashboard_box">
                <img
                  src={new URL("../../assets/st_bx_two.webp", import.meta.url)}
                  alt=""
                />
                <span>Average APY</span>
                <h4>8.5%</h4>
              </div>{" "}
              <div className="dashboard_box">
                <img
                  src={
                    new URL("../../assets/st_bx_three.webp", import.meta.url)
                  }
                  alt=""
                />
                <span>Active Stakers</span>
                <h4>12,300</h4>
              </div>{" "}
              <div className="dashboard_box">
                <img
                  src={new URL("../../assets/st_bx_four.webp", import.meta.url)}
                  alt=""
                />
                <span>Your Staked Assets</span>
                <h4>$5200</h4>
              </div>
            </div>
          </div>

          <h4 className="dsh_subtitle mt-4 mt-sm-5">Available Assets</h4>

          <div className="dsh_inv_grid mt-4">
            {stakeData.map((item) => (
              <div key={item.id} className="dsh_inv_card market_card">
                <div className="dsh_inv_head">
                  <div className="dsh_inv_top mrkt_top_title">
                    <div className="mrkt_top_content">
                      <img
                        className="img_div"
                        src={item.logoImg}
                        alt={item.title}
                      />
                      <h6>{item.cardTitle}</h6>
                    </div>

                    {/* {item.activeStatus ? (
                      <span className="mrkt_sts">Active</span>
                    ) : (
                      ""
                    )} */}
                  </div>
                  <img src={item.cardImg} alt={item.title} />
                  <div className="mrkt_main_cd_tlt mx-0">
                    <h3>{item.cardTitle}</h3>
                    <h5>{item.cardSubTitle}</h5>
                    <p>{item.description}</p>
                  </div>

                  <div className="dsh_inv_card_cnt">
                    <div className="dsh_inv_cd_flx">
                      {item.details.slice(0, 2).map((d, i) => (
                        <div key={i} className="dsh_inv_cd_lft">
                          <span>{d.label}</span>
                          <h4>{d.value}</h4>
                        </div>
                      ))}
                    </div>
                    <div className="dsh_inv_cd_flx mt-4">
                      {item.details.slice(2, 4).map((d, i) => (
                        <div key={i} className="dsh_inv_cd_lft">
                          <span>{d.label}</span>
                          <h4>{d.value}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <button className="dsh_inv_btn st_bx_btn">
                  <Link to={"/stake-details"}>{item.buttonText}</Link>
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
};

export default Stake;
